module.exports = __webpack_public_path__ + "img/bp_giftbg_0011.21044d5a.png";